module.exports = __webpack_public_path__ + "img/wechat_scan_desc.1c5b2155.png";